import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchNotice(payload) {
  return { type: actionTypes.FETCH_ONE, payload };
}
export function fetchNoticeSuccess(payload) {
  // console.log('payload', payload)
  const byId = { [payload.postUid]: payload };
  return { type: actionTypes.FETCH_ONE_SUCCESS, payload: { byId } };
}
export function fetchNotices(payload) {
  return { type: actionTypes.FETCH_COLLECTION, payload };
}
export function fetchNoticesSuccess(paylaod) {
  // console.log('connection....', paylaod)
  // console.log('post...', posts, params)
  const byId = keyBy(paylaod, (con) => con.postUid);
  // console.log('byid....', byId)
  return { type: actionTypes.FETCH_COLLECTION_SUCCESS, payload: { byId } };
}
export function saveFavorite(payload) {
  return { type: actionTypes.SAVE_FAVORITE, payload }
}
export function saveFavoriteSuccess(payload) {
  // console.log('savefavorite...', payload)
  return { type: actionTypes.SAVE_FAVORITE_SUCCESS, payload }
}
export function removeFavorite(payload) {
  return { type: actionTypes.REMOVE_FAVORITE, payload }
}
export function removeFavoriteSuccess(payload) {
  return { type: actionTypes.REMOVE_FAVORITE_SUCCESS, payload }
}
export function getFavorites(payload) {
  return { type: actionTypes.GET_FAVORITES, payload }
}
export function getFavoritesSuccess(payload) {
  // console.log('favorites....', payload)
  const byId = keyBy(payload, (fav) => (fav.favoriteUid));
  return { type: actionTypes.GET_FAVORITES_SUCCESS, payload: { byId } }
}
export function getNoticesReadPosts(payload) {
  return { type: actionTypes.GET_READ_POSTS, payload }
}
export function getNoticesReadPostsSuccess(payload) {
  const byId = keyBy(payload, (read) => (read.posts_postUid));
  return { type: actionTypes.GET_READ_POSTS_SUCCESS, payload: { byId } }
}
export function saveNoticesReadPost(payload) {
  return { type: actionTypes.SAVE_READ_POST, payload }
}
export function saveNoticesReadPostSuccess(payload) {
  return { type: actionTypes.SAVE_READ_POST_SUCCESS, payload }
}